export default __webpack_public_path__ + "static/media/liver-care.dab4f2a3.png";